import React, { useState, useEffect } from 'react'
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

//Componentes
import Cookies from 'universal-cookie'

//BLUEMOON
import Logo from '../paginas/img/Logo fondo blanco-03.png'
import '../paginas/estilos/estilos_admin.css'
import Avatar from '../paginas/img/avatar.jpg'

import '../paginas/estilos/estilos.css'

import BotonAdmin from '../componentesAdmin/componentes/BotonAdmin.js'
import HeaderUserPrin from '../componentesAdmin/componentes/HeaderUserPrin.js'
import useTraeDatos from '../componentesAdmin/hooks/useTraeDatos';

// //Modulos
import UsuariosAdmin from '../componentesAdmin/usuarios/UsuariosAdmin'
import CursosAdmin from '../componentesAdmin/cursos/CursosAdmin'
import TemasAdmin from '../componentesAdmin/temas/TemasAdmin'
import AprobadosAdmin from '../componentesAdmin/aprobados/AprobadosAdmin'

import ProductosAdmin from '../componentesAdmin/productos/ProductosAdmin.js'
import SubirProductos from '../componentesAdmin/productos/SubirProductos.js'
import CategoriasAdmin from '../componentesAdmin/productos/CategoriasAdmin.js'
import AtributosAdmin from '../componentesAdmin/productos/AtributosAdmin.js'
import UbicacionesAdmin from '../componentesAdmin/envios/UbicacionesAdmin.js'
import ZonasDeEnvio from '../componentesAdmin/envios/ZonasdeEnvio.js'
import ReglasdeEnvio from '../componentesAdmin/reglasdeenvio/ReglasdeEnvio.js'
import Cargas from '../componentesAdmin/cargas/CargasAdmin.js'
import Pedidos from '../componentesAdmin/pedidos/Pedidos.js'
import CertificadosAdmin from '../componentesAdmin/certificados/CertificadosAdmin.js'
import { CreadorPaginas } from '../componentesAdmin/paginas/CreadorPaginas';
import BannerAdmin from '../componentesAdmin/banner/BannerAdmin'
import CuponesAdmin from '../componentesAdmin/cupones/CuponesAdmin';
import NivelesAdmin from '../componentesAdmin/niveles/NivelesAdmin';
import OpcionesPagina from '../componentesAdmin/componentes/CreadorPaginas/componentes/OpcionesPagina';
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import Inventario from '../componentesAdmin/inventario/Inventario';
import MediosdePagoAdmin from '../componentesAdmin/mediosdepago/MediosdePagoAdmin';
import InformesAdmin from '../componentesAdmin/informes/InformesAdmin';
import VerCierresdeCaja from '../componentesAdmin/cierresdecaja/VerCierresdeCaja';
import Estadisticas from '../componentesAdmin/informes/Estadisticas';
import ItemsAppAdmin from '../componentesAdmin/items/ItemsAppAdmin';
import CrmAdmin from '../componentesAdmin/crm/CrmAdmin';
import EstadosAdmin from '../componentesAdmin/crm/Estados/EstadosAdmin';
import CampanasAdmin from '../componentesAdmin/crm/Campanas/CampanasAdmin';


const Admin = () => {
	const location = useLocation()
	const childRef = useRef();

	const APLICACION = process.env.REACT_APP_NAME_APP
	//almacena toda la data de mediodePagos 
	const cookies = new Cookies()

	//const {baseUrl, titulo, sede, nombreImpuesto, urlProducto} = _config._config
	const baseUrl = process.env.REACT_APP_BASE_URL
	//console.log('baseUrl',baseUrl)
	const api = process.env.REACT_APP_API
	const NombreUsuario = cookies.get('nombre')
	const idUsuario = cookies.get('id')
	const Usuario = cookies.get('usuario')
	const Roll = cookies.get('roll')
	//const history = useHistory();
	const navigate = useNavigate();
	const nombreImpuesto = process.env.REACT_APP_NOMBRE_INPUESTO

	//Urls

	const urlUsuarios = baseUrl + api + 'usuarios/'
	const urlCursos = baseUrl + api + 'cursos/'
	const urlTemas = baseUrl + api + 'temas/'
	const urlAprobados = baseUrl + api + 'aprobados/'

	const urlProductos = baseUrl + api + 'productos/'
	const urlCat = baseUrl + api + 'categorias/'
	const urlAtributos = baseUrl + api + 'atributos/'
	const urlUbicaciones = baseUrl + api + 'ubicaciones/'
	const urlZonasdeEnvio = baseUrl + api + 'zonasdeenvio/'
	const urlCargas = baseUrl + api + 'cargas/'
	const urlPedidos = baseUrl + api + 'pedidos/'
	const urlReglas = baseUrl + api + 'reglasdeenvio/'
	const urlCertificados = baseUrl + api + 'certificados/'
	const urlCierres = baseUrl + api + 'cierresdecaja/'

	const urlSeguimientoPedido = baseUrl + api + 'seguimientopedido/'

	const urlCreadorPaginas = baseUrl + api + 'paginas/'

	const urlBanner = baseUrl + api + 'banner/'
	const urlCupon = baseUrl + api + 'cupones/'
	const urlNiveles = baseUrl + api + 'niveles/'

	const urlHistoriaIngre = baseUrl + api + 'inventarios/'
	const urlmediosdePago = baseUrl + api + 'mediosdepago/'

	const urlItems = baseUrl + api + 'items/'

	//CRM:
	const urlEstados = baseUrl + api + 'estados/'
	const urlCrm = baseUrl + api + 'crm/'
	const urlAsesores = baseUrl + api + 'crm/asesores.php'
	const urlInteracciones = baseUrl + api + 'crm/interacciones.php'
	const urlPedidosCliente = baseUrl + api + 'crm/pedidos.php'
	const urlCampanas = baseUrl + api + 'crm/campanas.php'



	//ESTADOS
	const [cursos] = useTraeDatos(urlCursos)
	const [menuActive, setMenuActive] = useState(true)

	//---------------------PAGINA DE INICIO -----------------------
	const [seleccionado, setSeleccionado] = useState(location?.state?.url === "Inventario" ? "Inventario" : Roll === 'Master' ? 'Actividades' : Roll === 'Comercial' ? 'Pedidos' : 'Cursos')
	const [mostrarOpciones, setMostrarOpciones] = useState(false)
	const [tipoElementoSeleccionado, setTipoElementoSeleccionado] = useState({})
	//-------------------------------------------------------------

	const seleccionar = pagina => e => {
		setSeleccionado(pagina)
		setMostrarOpciones(false)
	}

	const cerrarSesion = (nombre) => e => {
		cookies.remove('id', { path: "/" })
		cookies.remove('nombre', { path: "/" })
		cookies.remove('usuario', { path: "/" })
		cookies.remove('roll', { path: "/" })
		navigate('/');
	}

	useEffect(() => {
		document.title = "Admin - BlueMoon"

		if (!cookies.get('usuario')) {
			//history.push("/")
			navigate("/")
		}

	}, [])

	const irAPos = () => e => {
		navigate("/pos")
	}


	const editarChildren = (props) => {
		setMostrarOpciones(false)
		setTimeout(() => {
			setMostrarOpciones(true)
			setTipoElementoSeleccionado(props)
		}, 100);
	}

	const handleEstilosComponente = (props) => childRef.current.handleEstilosComponente(props)

	const cerrarModal = () => setMostrarOpciones(false)

	return (
		<div className="row principal">
			{
				mostrarOpciones && (
					<div className='opciones-creador-paginas'>
						<div className='barra-izquierda-container'>
							<div className="barra-izquierda-opciones">
								<div className='botones-utiles'>
									<button className="botones-utiles-remover" type='button' onClick={() => setMostrarOpciones(false)}> <FontAwesomeIcon icon={faX} size="lg" /></button>
								</div>
								<OpcionesPagina {...tipoElementoSeleccionado} handleEstilosComponente={handleEstilosComponente} />
							</div>
						</div>
					</div>
				)
			}
			<div className="col-xs-12 col-sm-12 col-md-3">
				<div className="barra_izquierda">

					<HeaderUserPrin Logo={Logo} Avatar={Avatar} nombre={NombreUsuario} idUsuario={idUsuario} Roll={Roll} usuario={Usuario} menuActive={menuActive} setMenuActive={setMenuActive} />

					<div className={menuActive ? 'activo' : 'hidden'}>
						{
							{
								'Admin': <>

									<BotonAdmin nombre={'Cursos'} onClick={seleccionar} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
									<BotonAdmin nombre={'Pedidos'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Sistema Pos'} onClick={irAPos} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
									<BotonAdmin nombre={'Temas'} onClick={seleccionar} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
									<BotonAdmin nombre={'Actividades'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Certificados'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Productos'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									{seleccionado === 'Productos' || seleccionado === 'Ver Productos' || seleccionado === 'Subir Productos' || seleccionado === 'Categorías' || seleccionado === 'Atributos' ?
										<div>
											<BotonAdmin nombre={'Ver Productos'} sub={true} onClick={seleccionar} active={seleccionado} />
											<BotonAdmin nombre={'Categorías'} sub={true} onClick={seleccionar} active={seleccionado} />
											<BotonAdmin nombre={'Atributos'} sub={true} onClick={seleccionar} active={seleccionado} />
										</div>
										: null}
									<BotonAdmin nombre={'Informes'} onClick={seleccionar} active={seleccionado} roll={Roll} verPara={'Vendedor'} />

									{seleccionado === 'Informes' || seleccionado === 'Estadisticas' ? (<div> <BotonAdmin nombre={'Estadisticas'} sub={true} onClick={seleccionar} active={seleccionado} /></div>) : null
									}
									<BotonAdmin nombre={'Cierres de Caja'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Historial de Inventario'} onClick={() => seleccionar('Inventario')} active={seleccionado} />
									<BotonAdmin nombre={'Usuarios'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Cargas de Envio'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Reglas de Envio'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Publicidad'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Cupones'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Niveles'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Creador Paginas'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Medios de Pago'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									<BotonAdmin nombre={'Items App'} onClick={seleccionar} active={seleccionado} roll={Roll} />

									<BotonAdmin nombre={'CRM'} onClick={seleccionar} active={seleccionado} roll={Roll} />
									{seleccionado === 'CRM' || seleccionado === 'Estados' || seleccionado === 'Campañas' || seleccionado === 'Clientes' ?
										<div>
											<BotonAdmin nombre={'Clientes'} sub={true} onClick={seleccionar} active={seleccionado} />
											<BotonAdmin nombre={'Estados'} sub={true} onClick={seleccionar} active={seleccionado} />
											<BotonAdmin nombre={'Campañas'} sub={true} onClick={seleccionar} active={seleccionado} />
										</div>
										: null}
									<BotonAdmin nombre={'Cerrar Sesión'} onClick={cerrarSesion} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
								</>,
								'Master':
									<>
										<BotonAdmin nombre={'Actividades'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										<BotonAdmin nombre={'Certificados'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										<BotonAdmin nombre={'Cerrar Sesión'} onClick={cerrarSesion} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
									</>,
								'Comercial':
									<>
										<BotonAdmin nombre={'Pedidos'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										<BotonAdmin nombre={'Sistema Pos'} onClick={irAPos} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
										<BotonAdmin nombre={'Productos'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										{seleccionado === 'Productos' || seleccionado === 'Ver Productos' || seleccionado === 'Subir Productos' || seleccionado === 'Categorías' || seleccionado === 'Atributos' ?
											<div>
												<BotonAdmin nombre={'Ver Productos'} sub={true} onClick={seleccionar} active={seleccionado} />
												<BotonAdmin nombre={'Categorías'} sub={true} onClick={seleccionar} active={seleccionado} />
												<BotonAdmin nombre={'Atributos'} sub={true} onClick={seleccionar} active={seleccionado} />
											</div>
											: null}
										<BotonAdmin nombre={'Informes'} onClick={seleccionar} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
										<BotonAdmin nombre={'Cierres de Caja'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										<BotonAdmin nombre={'Historial de Inventario'} onClick={() => seleccionar('Inventario')} active={seleccionado} />
										<BotonAdmin nombre={'Usuarios'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										<BotonAdmin nombre={'Cargas de Envio'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										<BotonAdmin nombre={'Cupones'} onClick={seleccionar} active={seleccionado} roll={Roll} />
										<BotonAdmin nombre={'Medios de Pago'} onClick={seleccionar} active={seleccionado} roll={Roll} />

										<BotonAdmin nombre={'Cerrar Sesión'} onClick={cerrarSesion} active={seleccionado} roll={Roll} verPara={'Vendedor'} />
									</>
							}[Roll]
						}
					</div>

				</div>
			</div>
			<div className="col-xs-12 col-sm-12 col-md-9">
				<div className="barra_derecha">

					<div className="contenedorAdmin">

						<div className="contenedor">


							{seleccionado === 'Pedidos' ?
								<Pedidos
									titulo={seleccionado}
									baseUrl={urlPedidos}
									baseUrlProductos={urlProductos}
									baseUrlCursos={urlCursos}
									baseUrlActual={baseUrl + api}
									Titulo={'Ver Pedidos'}
									usuario={'Emanuel'}
									baseUrlSeguimiento={urlSeguimientoPedido}
									logo={Logo}
									urlCupon={urlCupon} />
								: null}

							{seleccionado === 'Zonas de Envio' ?
								<ZonasDeEnvio
									baseUrl={urlZonasdeEnvio}
									Titulo={'Zonas de Envio'}
									baseUrlUbica={urlUbicaciones} />
								: null}

							{seleccionado === 'Cargas de Envio' ?
								<Cargas
									baseUrl={urlCargas}
									Titulo={'Cargas de Envio'} />
								: null}

							{seleccionado === 'Reglas de Envio' ?
								<ReglasdeEnvio
									baseUrl={urlReglas}
									Titulo={'Reglas de Envio'} />
								: null}



							{seleccionado === 'Ubicaciones' ?
								<UbicacionesAdmin baseUrl={urlUbicaciones} Titulo={'Ubicaciones'} />
								: null}

							{seleccionado === 'Productos' ?
								<ProductosAdmin
									baseUrl={urlProductos}
									baseUrlCursos={urlCursos}
									nombreImpuesto={nombreImpuesto}
									urlCat={urlCat}
									urlAtributos={urlAtributos}
									Titulo={'Ver Productos'}
									baseURLInventarios={urlHistoriaIngre}
								/>
								: null}

							{seleccionado === 'Ver Productos' ?
								<ProductosAdmin

									baseUrl={urlProductos}
									baseUrlCursos={urlCursos}
									nombreImpuesto={nombreImpuesto}
									urlCat={urlCat}
									urlAtributos={urlAtributos}
									Titulo={'Ver Productos'} />
								: null}

							{seleccionado === 'Subir Productos' ?
								<SubirProductos
									baseUrl={urlProductos}
									baseUrlCursos={urlCursos}
									nombreImpuesto={nombreImpuesto}
									urlCat={urlCat}
									urlAtributos={urlAtributos}
									Titulo={'Subir Productos'} />
								: null}


							{seleccionado === 'Atributos' ?
								<AtributosAdmin baseUrl={urlAtributos} Titulo={'Atributos'}
								/>
								: null}


							{seleccionado === 'Categorías' ?
								<CategoriasAdmin baseUrlCat={urlCat} Titulo={'Categorías'} />
								: null}

							{seleccionado === 'Certificados' ?
								<CertificadosAdmin
									titulo={'Certificados'}
									urlCertificados={urlCertificados}
									urlUsuarios={urlUsuarios}
									urlCursos={urlCursos}
								/>
								: null}


							{seleccionado === 'Actividades' ?
								<AprobadosAdmin
									urlAprobados={urlAprobados}
									titulo={'Actividades'}
									urlCertificados={urlCertificados}
								/>
								: null}

							{seleccionado === 'Cursos' ?
								<CursosAdmin
									urlCursos={urlCursos}
									titulo={'Cursos'}
								/>
								: null}

							{seleccionado === 'Temas' ?
								<TemasAdmin
									urlTemas={urlTemas}
									titulo={'Temas'}
									urlCursos={urlCursos}
									urlProductos={urlProductos}
								/>
								: null}


							{seleccionado === 'Usuarios' ?
								<UsuariosAdmin
									baseUrl={urlUsuarios}
									Titulo={'Usuarios'}
									cursos={cursos}
									urlPedidos={urlPedidos} />
								: null}

							{seleccionado === 'CRM' || seleccionado === 'Clientes' ?
								<CrmAdmin
									baseUrl={urlCrm}
									Titulo={'CRM'}
									cursos={cursos}
									urlPedidos={urlPedidos}
									urlEstados={urlEstados}
									urlAsesores={urlAsesores}
									urlInteracciones={urlInteracciones}
									urlPedidosCliente={urlPedidosCliente}
									urlProductos={urlProductos}
									urlCampanas={urlCampanas}
								/>
								: null}

							{seleccionado === 'Estados' ?
								<EstadosAdmin
									baseUrl={urlEstados}
									Titulo={'Estados CRM'}
									cursos={cursos}
									urlPedidos={urlPedidos}
								/>
								: null}

							{seleccionado === 'Campañas' ?
								<CampanasAdmin
									baseUrl={urlUsuarios}
									baseUrlEstados={urlEstados}
									Titulo={'Campañas CRM'}
									cursos={cursos}
									urlPedidos={urlPedidos}
									urlCampanas={urlCampanas}
								/>
								: null}




							{seleccionado === 'Publicidad' ?
								<BannerAdmin
									urlbanner={urlBanner}
									urlcategorias={urlCat}
									titulo={'Banner'}
								/>
								: null}
							{seleccionado === 'Cupones' ?
								<CuponesAdmin
									urlcupon={urlCupon}
									titulo={'Cupon'}
								/>
								: null}

							{seleccionado === 'Niveles' ?
								<NivelesAdmin
									baseUrl={urlNiveles}
									Titulo={'Niveles'} />
								: null}

							{seleccionado === 'Items App' ?
								<ItemsAppAdmin
									baseUrl={urlItems}
									Titulo={'Items App'} />
								: null}

							{seleccionado === 'Creador Paginas' ?
								<CreadorPaginas
									editarChildren={editarChildren}
									ref={childRef}
									baseUrl={urlCreadorPaginas}
									titulo={'Crear Paginas'}
									cerrarModal={cerrarModal}
								/>
								: null}

							{seleccionado === 'Inventario' ?
								<Inventario
									baseUrl={urlHistoriaIngre}
									usuario={cookies.get('nombre')}
									Titulo={'Historial de Inventario'}
									urlProductos={urlProductos}
								/>
								: null}
							{seleccionado === 'Medios de Pago' ?
								<MediosdePagoAdmin baseUrl={urlmediosdePago} Titulo='Medios de Pago' />
								: null}


							{seleccionado === 'Informes' ?
								<InformesAdmin
									baseUrl={urlPedidos}
									Titulo={'Informes'}
									baseMediosdePago={urlmediosdePago}
									baseUsuarios={urlUsuarios}
									config={{}}
									usuario={cookies.get('nombre')}
									baseCierres={urlCierres}
									roll={Roll} />
								: null}

							{seleccionado === 'Estadisticas' && (<Estadisticas baseUrl={urlPedidos} Titulo={'Estadisticas'} />)
							}


							{seleccionado === 'Cierres de Caja' ?
								<VerCierresdeCaja Titulo={'Cierres de Caja'} baseUrl={urlCierres} usuario={cookies.get('nombre')} />
								: null}


						</div>
					</div>
				</div>
			</div>
		</div>

	)
}



export default Admin